import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { PreviousFiltersStore } from './types';

const initialState: PreviousFiltersStore = {
  destinationId: null,
  filters: {},
  adults: null,
  kids: null,
  isSuggestedFiltersShown: null,
  searchType: null,
};

const previousFiltersSlice = createSlice({
  name: 'previousFilters',
  initialState,
  reducers: {
    setPreviousFiltersToSlice: (
      _state,
      action: PayloadAction<PreviousFiltersStore>,
    ) => action.payload,
    setIsPreviousFiltersShown(state, action: PayloadAction<boolean>) {
      state.isSuggestedFiltersShown = action.payload;
    },
  },
});

export const { name } = previousFiltersSlice;
export const { setIsPreviousFiltersShown, setPreviousFiltersToSlice } =
  previousFiltersSlice.actions;
export default previousFiltersSlice.reducer;
